import React from 'react';
import ReactDOM from 'react-dom';
import Carousel from './carousel.js';

if (document.querySelector('#carousel')) {
  var itemCount = document.querySelector('#carousel').getElementsByTagName('article').length;
  var namePrefix = 'Get to know';

  document.getElementById('carousel').classList.add('carousel-count-' + itemCount);

  if (itemCount == 1) {
    document.querySelector('.carousel-slider').style.padding = '0';
    document.querySelector('.carousel-slide').setAttribute('style', 'display:block; margin: 0px auto !important; width: 24%');
    document.querySelector('.field-name-first a').innerHTML = namePrefix + ' ' + document.querySelector('.field-name-first a').innerHTML;
  }
  else if (itemCount > 3 || (itemCount == 3 && window.innerWidth < 1920) || window.innerWidth < 1024) {
    ReactDOM.render(<React.StrictMode><Carousel /></React.StrictMode>, document.getElementById('carousel'));
  }
  else {
    var articleList = document.querySelector('#carousel').getElementsByTagName('article');

    for (var i = 0; i < articleList.length; i++) {
      articleList[i].querySelector('.field-name-first a').innerHTML = namePrefix + ' ' + articleList[i].querySelector('.field-name-first a').innerHTML;
    }
  }
}
